import { UserProfile } from './UserProfile'

export const vsServiceName = 'userProfile'
export const vsProviderName = 'userProfileProvider'

export class UserProfileProvider {
  constructor(profile) {
    this.profile = new UserProfile(profile)
  }

  $get() {
    return this.profile
  }
}

UserProfileProvider.prototype.$get.$inject = []